$(function () {

    $(document).ready(function () {

        if ($(document).width() <= 992) {
            InitLinkCarousel();
        }

        $(document).resize(function () {
            if ($(document).width() <= 992) {
                InitLinkCarousel();
            }
        });

        // set up custom dropdowns for links
        $(document).on('click', function (e) {
            var currentItem = $(e.target);

            if (currentItem.parents('.dropdown').length > 0) {
                var dropdown = currentItem.parents('.dropdown');

                // close all other dropdowns
                var dropdowns = $('.dropdown');
                dropdowns.each(function (i, e) {
                    if (!$(this).is(dropdown)) {
                        $(this).find('.hidden-items').removeClass('show');
                    }
                });

                // show/hide current one
                dropdown.find('.hidden-items').toggleClass('show');
            }
            else if (currentItem.is('.dropdown')) {

                // close all other dropdowns
                var dropdowns = $('.dropdown');
                dropdowns.each(function (i, e) {
                    if (!$(this).is(currentItem)) {
                        $(this).find('.hidden-items').removeClass('show');
                    }
                });

                // show/hide current one
                currentItem.find('.hidden-items').toggleClass('show');
            }
            else {
                $('.dropdown').find('.hidden-items').removeClass('show');
            }
        });

    });

});

function InitLinkCarousel() {

    // set up the carousel of links
    $('.link-carousel').owlCarousel({
        autoplay: true,
        dots: false,
        nav: false,
        loop: true,
        navText: ["<i class='fa fa-chevron-left fa-lg'></i>", "<i class='fa fa-chevron-right fa-lg'></i>"],
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            }
        }
    });

}